import STRING from "string";
let originParams = {};
let headers = {};
export const getOrigin = function () {
  let userAgents = navigator.userAgent;
  console.log(userAgents, "userAgents");
  userAgents = decodeURIComponent(userAgents);
  console.log(
    userAgents,
    "decodeURIComponent(userAgents)",
  );
  if (process.env.NODE_ENV === "development") {
    //只允许再测试环境
    // 员工
    // userAgents =
    //   'FXEYE-BIB-IOS-WIKIFX{"wikistock":"ios","language":"fil","userId":"4164486221","wikinum":"7271251640","falg":"https://img.tech002.com/flag/7d8833382673bab2/CN.png_wiki-template-global","phonecode":"0086","isVip":"0","hasWhatsApp":true,"showname":"","LanguagePreference":"zh-CN","nick":"FX4164486221","avatar":"https://img.zy223.com/WikiEnterprise/sign/personph.png_wiki-template-global","countrycode":"156","twoCharCode":"CN","BasicData":"0,157,3,389,0,4181a540-1b5d-11f1-b54d-5d827d045421,0","navHeight":48.0,"istwopane":"singleScreen","email":"","fxintl":"1"}';
    //实盘 1601454949 2701896216
    // userAgents =
    //   'FXEYE-BIB-ANDROID-WIKIFXF4386749971BFE8{"language":"zh-CN","userId":"2701896216","avatar":"https://img.fx696.com/avatar/1719914836/1719914836_80347.jpg_wiki-template-global","countrycode":"156","BasicData":"1,33,3,381,0,dfe42692099864e5,0","showname":"","LanguagePreference":"en","navHeight":50.285714285714285,"enterpriseCode":"","enterpriseType":"","level":999,"twoCharCode":"CN","isAppBaseRoute":"https://eco.tech003.com/zh-cn","hasWhatsApp":true}';
    // userAgents = 'FXEYE-BIB-ANDROID-WIKIFXF4386749971BFE8{"language":"zh-cn","userId":"3255672718","avatar":"https://img.fx696.com/avatar/3255672718/3255672718_76661.jpg_wiki-template-global","countrycode":"156","navHeight":35.55555555555556,"enterpriseCode":"74405702","enterpriseType":"1","level":2,"twoCharCode":"CN","isAppBaseRoute":"https://eco.tech003.com/zh-cn/releaseManage/newsedit/202309226784644710.html?fromApp=true"}'
    // 服务商管理员
    // userAgents = 'FXEYE-BIB-ANDROID-WIKIFXF4386749971BFE8{"language":"zh-CN","userId":"3255672718","avatar":"https://img.fx696.com/avatar/0000000000.png_wiki-template-global","countrycode":"156","BasicData":"1,29,3,300,0,1631d8a81fc25ca1,0","showname":"","LanguagePreference":"zh-CN","navHeight":36.0,"enterpriseCode":"","enterpriseType":"","level":999,"twoCharCode":"CN","isAppBaseRoute":"https://eco.tech003.com/zh-cn","color":"#FFCC66","logo":"https://eimgjys.fx696.com/logo/default/serviceprovider.png_wiki-template-global","annotation":"","project":3,"showName":"xxx66666","score":"1.30","scoreLevel":"0.5","labels":["桥接","CRM"],"hasWhatsApp":false}'
  }

  if (
    userAgents.includes("FXEYE-BIB-IOS-WIKIFX") ||
    userAgents.includes(
      "FXEYE-BIB-ANDROID-WIKIFX",
    ) ||
    userAgents.includes("WIKIBIT-BIB-IOS") ||
    userAgents.includes("WIKIBIT-BIB-ANDROID")
  ) {
    const _isios = userAgents.includes("BIB-IOS");
    originParams =
      "{" +
      STRING(userAgents).between("{", "}").s +
      "}";
    originParams = JSON.parse(originParams);
    originParams.language =
      originParams.language?.toLowerCase();
    let newArr = [];
    if (originParams?.labels?.length > 0) {
      originParams?.labels.forEach((el) => {
        newArr.push({
          data: [
            {
              labelName: el,
            },
          ],
        });
      });
    }

    if (
      originParams.language == "zh-tw" ||
      originParams.language == "zh-hk"
    )
      originParams.language = "zh";
    headers =
      {
        isBusinessCardFromApp:
          originParams?.isBusinessCardFromApp ||
          false, //名片回退的
        navTitle: originParams.showname, //
        language:
          originParams.language || "zh-cn",
        userId: originParams.userId || null,
        countrycode: originParams.countrycode,
        wikinum: originParams.wikinum,
        falg: originParams.falg,
        phonecode: originParams.phonecode,
        myCountry: originParams.countrycode,
        LanguagePreference:
          originParams.LanguagePreference,
        BasicData: originParams.BasicData,
        navHeight: originParams.navHeight,
        enterpriseCode:
          originParams.enterpriseCode,
        enterpriseType:
          originParams.enterpriseType,
        isAppBaseRoute:
          originParams.isAppBaseRoute,
        // nick: originParams?.nick,
        avatar:
          originParams?.avatar ||
          "http://resources1.interface003.com/eco/img/common/default-avatar.png",
        isRelease: originParams?.isRelease, // 是否为发布页面
        marketTopicCode:
          originParams?.topicCode || "",
        AppCategoryId:
          originParams?.categoryId || "",
        hasWhatsApp:
          originParams?.hasWhatsApp || false,
        level: Number(originParams?.level),
        isCreate: originParams?.logo
          ? true
          : false,
        isReister: originParams?.isReister,
        isios: _isios,
        aggDataInfo: {
          color: originParams?.color,
          logo: originParams?.logo,
          annotation: originParams?.annotation,
          project: originParams?.project,
          showName: originParams?.showName,
          score: originParams?.score,
          scoreLevel: originParams?.scoreLevel,
          labels: newArr,
        },
        isGlobal: !!(
          originParams?.fxintl &&
          Number(originParams?.fxintl)
        ), // 是否为国际版
      } || {};
    // console.log(headers,'headers');
    console.log("userAgents::: ", userAgents);
    return headers;
  }
};
